import classNames from 'classnames';
import React, { CSSProperties } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import './index.less';

export enum TeamTagType {
    personal = 'personal',
    team = 'team',
    enterprise = 'enterprise',
    free = 'free',
}

interface ITeamTag {
    type: TeamTagType;
    size: 'large' | 'medium' | 'small';
    /** 下拉箭头 */
    selectIcon?: boolean;
    /** 灰色处理 */
    grayscale?: boolean;
    /** 样式 */
    style?: CSSProperties;
    onClick?: () => void;
}

const nameType = {
    personal: '个人版',
    team: '团队版',
    enterprise: '企业版',
    free: '免费版',
};

/**
 * 团队 tag
 */
const TeamTag: React.FC<ITeamTag> = ({ size, type, selectIcon, grayscale, style = {}, onClick }) => {
    return (
        <div
            className={classNames('Widget', `teamTag`, type, size, {
                grayscale,
                selectIcon: !!selectIcon,
            })}
            style={{ ...style }}
            onClick={() => onClick?.()}
        >
            <span className="txt">{nameType[type]}</span>
            {selectIcon ? (
                <span
                    style={{
                        transform: `translate(1px, -50%) scale(${8 / 12})`,
                        position: 'absolute',
                        top: '50%',
                    }}
                >
                    <IconFont fontSize={12} name="ChevronDownBlack" />
                </span>
            ) : null}
        </div>
    );
};

export default React.memo(TeamTag);
